/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignalRMsgPrinterStatusResponse } from '../../models/signal-r-msg-printer-status-response';

export interface HubsHubKioskSendPrinterStatusPost$Params {
  response?: SignalRMsgPrinterStatusResponse;
}

export function hubsHubKioskSendPrinterStatusPost(http: HttpClient, rootUrl: string, params?: HubsHubKioskSendPrinterStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, hubsHubKioskSendPrinterStatusPost.PATH, 'post');
  if (params) {
    rb.query('response', params.response, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

hubsHubKioskSendPrinterStatusPost.PATH = '/hubs/HubKiosk/SendPrinterStatus';
